{
    "Title": "Gerenciar filas",
    "ManageQueuesDescriptionTitle": "Descrição",
    "ManageQueuesCQConfigurationsTitle": "Configurações CQ",
    "ManageQueuesResourceAccountsTitle": "Contas de Recursos",
    "ManageQueuesMonitoringStatusTitle": "Status de monitoramento",
    "ManageQueueFiltersTitle": "Filtros",
    "ManageQueueCallMonitoringHistoric": "Histórico",
    "ManageQueueCallMonitoringRealTime": "Em tempo real",
    "ManageQueueCallMonitoringRealTimeForced": "Tempo real (forçado)",
    "ManageQueueCallMonitoringUnknown": "Desconhecido",
    "ManageQueueCallCQConfigurationCompatible": "Compatível",
    "ManageQueueCallCQConfigurationIncompatible": "Incompatível",
    "ManageQueuesQueueFilterAll": "Todas as filas",
    "ManageQueuesFilterCompatible": "Filas Compatíveis",
    "ManageQueuesFilterIncompatible": "Filas incompatíveis",
    "ManageQueue_DisableEnableRealtime_Confirm": "Confirmar",
    "ManageQueue_DisableEnableRealtime_Cancel": "Cancelar",
    "ManageQueue_MonitorAllMessage": "Tem certeza de que deseja habilitar o monitoramento em tempo real para todas as filas?",
    "ManageQueue_UnmonitorAllMessage": "Tem certeza de que deseja desativar o monitoramento em tempo real para todas as filas?",
    "ManageQueue_Loading_Monitoring_All": "Habilitando o monitoramento em tempo real para todas as filas",
    "ManageQueue_Loading_Unmonitoring_All": "Desabilitando o monitoramento em tempo real para todas as filas",
    "ManageQueue_Pending_Queue_Disabling": "Desabilitando o monitoramento...",
    "ManageQueue_Pending_Queue_Enabling": "Habilitando o monitoramento...",
    "ManageQueue_Disable_RT_Popper": "Desabilitar monitoramento em tempo real em todas as filas",
    "ManageQueue_Enable_RT_Popper": "Habilitar monitoramento em tempo real em todas as filas",
    "ManageQueues_Not_Found_Error": "Nenhuma fila correspondente a essa pesquisa foi encontrada",
    "NAME": "ManageQueues"
}